import { useCallback } from 'react';

import { locationAssign, locationReplace, useAutoNavigate } from '@betterment/js-runtime';

import type { EchoNavigation } from '../types';

export function useEchoNavigate() {
  const autoNavigate = useAutoNavigate();

  return useCallback(
    async ({ location, reload, replace }: EchoNavigation) => {
      if (reload && replace) {
        locationReplace(location);
      } else if (reload) {
        locationAssign(location);
      } else {
        await autoNavigate(location, { replace });
      }
    },
    [autoNavigate]
  );
}
